import React, { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Container,
  Row,
  Card,
  CardBody,
  CardHeader,
  Col,
  Spinner,
  Input,
  InputGroup,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { toast } from "react-toastify";
import { APIClient } from "../../../helpers/api_helper";
import AwesomePagination from "../../../Components/Common/AwesomePagination";
import moment from "moment";
import parse from "html-react-parser";
import FeatherIcon from "feather-icons-react";

const apiClient = new APIClient();

const Logs = ({ isLojista, isCliente }) => {
  const [loading, setLoading] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(true);
  const [termo, setTermo] = useState("");
  const [inputTermo, setInputTermo] = useState("");
  const [pagina, setPagina] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [totalItens, setTotalItens] = useState(0);
  const [logs, setLogs] = useState([]);

  const { userId } = useParams();
  const user_id = userId || 1;

  const user = JSON.parse(localStorage.getItem("authUser"));

  function formatName(name) {
    let lowerCaseName = name.toLowerCase();
    let properName = lowerCaseName.replace(
      /\b\w/g,
      function (letter, index, fullText) {
        const previousLetter = fullText[index - 1];
        const isWordAfterApostrophe = previousLetter === "'";
        if (isWordAfterApostrophe) {
          return letter;
        }
        const word = fullText.slice(index).match(/^\w+/)[0];
        const lowerCaseWords = ["de", "da", "do", "dos", "das"];
        if (lowerCaseWords.includes(word)) {
          return letter;
        }
        return letter.toUpperCase();
      }
    );

    // Converte a letra após um apóstrofo para maiúscula
    properName = properName.replace(/'\w/g, function (letter) {
      return letter.toUpperCase();
    });

    return properName;
  }

  const getLogs = useCallback(async () => {
    setLoading(true);
    const response = await apiClient.post(`/logs/system-logs/buscar`, {
      user_id: user_id,
      termo: termo,
      pagina: pagina,
      itens_pagina: 20,
    });

    if (response.sucesso) {
      setLogs(response.dados.data);
      setTotalPaginas(response.dados.last_page);
      setTotalItens(response.dados.total);
    } else {
      toast.error(response.mensagem);
    }
    setLoading(false);
  }, [user_id, pagina, termo]);

  useEffect(() => {
    if (shouldFetch) {
      const fetchData = async () => {
        await getLogs();
        setShouldFetch(false);
      };
      fetchData();
    }
  }, [shouldFetch, user_id, pagina, termo, getLogs]);

  document.title = "Logs | Painel Fort Exchange";

  const handleTermoKeyDown = (e) => {
    if (e.key === "Enter") {
      setTermo(inputTermo);
      setPagina(1);
      setShouldFetch(true);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Logs"
            pageTitle={
              isLojista ? "Lojista" : isCliente ? "Clientes Fort" : "Aplicações"
            }
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="d-flex align-items-center border-0">
                  <h5 className="card-title mb-0 flex-grow-1">
                    {user_id === 1 ? "Logs do Sistema" : "Logs do Usuário"}
                  </h5>
                </CardHeader>
                <CardBody>
                  {/* Campo de busca */}
                  <div className="mb-3">
                    <InputGroup>
                      <div className="input-group-text">
                        <FeatherIcon icon="search" className="icon-dual" />
                      </div>
                      <Input
                        type="text"
                        placeholder="Buscar por termo..."
                        value={inputTermo}
                        onChange={e => setInputTermo(e.target.value)}
                        onKeyDown={handleTermoKeyDown}
                      />
                    </InputGroup>
                  </div>
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <Spinner height={100} width={100} />
                    </div>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table align-middle table-nowrap mb-0">
                          <thead className="table-light">
                            <tr>
                              <th>Data</th>
                              <th>Nome</th>
                              <th>Mensagem de log</th>
                            </tr>
                          </thead>
                          <tbody>
                            {logs.length === 0 ? (
                              <tr>
                                <td colSpan={3} className="text-center text-muted py-4">
                                  Nenhum log encontrado.
                                </td>
                              </tr>
                            ) : (
                              logs.map((item, idx) => (
                                <tr key={item.id || idx}>
                                  {/* Data */}
                                  <td>
                                    <b>{moment(item.created_at).format("DD/MM/YYYY")} </b>
                                    <small className="text-muted">{moment(item.created_at).format("HH:mm")}</small>
                                  </td>
                                  {/* Nome */}
                                  <td>
                                    <Link to={`/clientes/${item.user_id}`} target="_self">
                                      <b>{formatName(item.user?.name || "-")}</b>
                                    </Link>
                                  </td>
                                  {/* Mensagem de log */}
                                  <td>
                                    <div>{parse(item.mensagem)}</div>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                      <AwesomePagination
                        pagina={pagina}
                        totalPaginas={totalPaginas}
                        setPagina={p => {
                          setPagina(p);
                          setShouldFetch(true);
                        }}
                      />
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Logs;
